export const MetaradarQueryKeys = {
	all: ['metaradar'] as const,
	companyHotel: (companyHotelId: number) => [...MetaradarQueryKeys.all, 'companyHotel', companyHotelId] as const,
	refreshStatus: (companyHotelId: number) => [...MetaradarQueryKeys.all, 'refreshStatus', companyHotelId] as const,
};
